export const getPercentage = (number: number, percentage: number) => {
    return (number * percentage) / 100
}